// extracted by mini-css-extract-plugin
module.exports = {"Container":"OfficeTrips_Container__3CnjY","Title":"OfficeTrips_Title__1w9zP","Description":"OfficeTrips_Description__15hmu","Image":"OfficeTrips_Image__2FPbd"};